import { frontloadConnect } from 'react-frontload';
import { connect } from 'react-redux';
import { OrganizationProps } from '@nykaa/jsonld-shared/schemas/Organization';
import { DeepSearchProps } from '@nykaa/jsonld-shared/schemas/DeepSearch';
import {
  generateOrganizationSchema as _generateOrganizationSchema,
  generateDeepSearchSchema as _generateDeepSearchSchema,
  JSONLdData,
} from '@nykaa/jsonld-shared/store/action';

import { fetchHomePageWidgets as _fetchHomePageWidgets } from 'shared/store/home/action';
import { getCustomPageType } from 'shared/store/home/helper';
import View from 'layouts/Landing';
import { State } from 'store/types';
import { FetchHomePageParams } from 'store/home/types';
import { HomePageConfig } from 'store/remoteConfig/types';
import { RouteComponentProps } from 'react-router-dom';

import PageTypes from 'constants/pageTypes';
import { DEFAULT_LANGUAGE, HOMEPAGE_PAGE_TYPE } from 'shared/constants';
import { LangState } from '@nykaa/intl-shared/types';
import { PagePrefixes } from 'constants/pagePrefixes';

const mapStateToProps = ({ homePage, remoteConfig, langConfig }: State) => ({
  widgets: homePage.widgets,
  loading: homePage.loading,
  configs: remoteConfig.configs.homePage,
  langConfig,
  isFetchingError: !!homePage.isFetchingError,
  pageName: PageTypes.HOME,
  loadInterFont: remoteConfig.switches.loadInterFont,
  isPaginationEnabled: remoteConfig.switches.isPaginationEnabled,
  remainingInventoryIds: homePage.remaining_inventories_ids,
  queryParamsObject: homePage.queryParams,
  organizationSeoSchema: remoteConfig?.configs?.organizationSeoSchema,
  deepSearchSeoSchema: remoteConfig?.configs?.deepSearchSeoSchema,
});

const mapDispatchToProps = {
  fetchHomePageWidgets: _fetchHomePageWidgets,
  generateOrganizationSchema: _generateOrganizationSchema,
  generateDeepSearchSchema: _generateDeepSearchSchema,
};

interface FetchDataParams extends RouteComponentProps<void> {
  fetchHomePageWidgets: (
    params: FetchHomePageParams,
    pagePrefix?: string,
    paginationEnabled?: boolean
  ) => Promise<void>;
  staticContext?: CustomStaticContext;
  configs: HomePageConfig;
  langConfig: LangState;
  isPaginationEnabled?: boolean;
  generateOrganizationSchema: (arg: JSONLdData) => void;
  organizationSeoSchema: OrganizationProps;
  generateDeepSearchSchema: (arg: JSONLdData) => void;
  deepSearchSeoSchema: DeepSearchProps;
}

const fetchData = async ({
  fetchHomePageWidgets,
  staticContext,
  configs,
  location,
  langConfig,
  isPaginationEnabled,
  generateOrganizationSchema,
  organizationSeoSchema = {},
  generateDeepSearchSchema,
  deepSearchSeoSchema,
}: FetchDataParams) => {
  const { storeId } = staticContext || {};
  const queryParams = new URLSearchParams(location.search);
  const customPageTypeInQuery = queryParams.get('customPageType');
  const customPageType = getCustomPageType(configs, customPageTypeInQuery);
  const { lang, isExperimentEnabled } = langConfig;
  const isVernacularEnabled =
    isExperimentEnabled && lang && lang !== DEFAULT_LANGUAGE;
  const paginationEnabled = !!isPaginationEnabled;

  if (organizationSeoSchema) {
    generateOrganizationSchema(organizationSeoSchema);
  }

  if (deepSearchSeoSchema) {
    generateDeepSearchSchema(deepSearchSeoSchema);
  }

  return fetchHomePageWidgets(
    {
      ...(storeId && { store: storeId }),
      ...(isVernacularEnabled && { page_type: HOMEPAGE_PAGE_TYPE, lang }),
      ...(customPageType && { page_type: customPageType }),
      ...(paginationEnabled && { api_version: 'V2' }),
    },
    PagePrefixes.HOMEPAGE,
    paginationEnabled
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(frontloadConnect(fetchData)(View));
